// extracted by mini-css-extract-plugin
module.exports = {"link":"ActivityDetail_link__3VQBK"};